import { Component, OnInit, ViewChild } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { ActivatedRoute } from '@angular/router';
import { EmailService } from "../../@core/api/email.service"
import { Email } from "../../@core/data/email"

@Component({
  selector: 'ngx-email-new',
  templateUrl: './email-new.component.html',
  styleUrls: ['./email-new.component.scss']
})
export class EmailNewComponent implements OnInit {
  email_id: string;
  email: Email = { name: "", uid: "", id: "" };
  constructor(private route: ActivatedRoute, private emailService: EmailService) { }

  async ngOnInit() {
    this.email_id = this.route.snapshot.params['id'];

    this.emailService.getEmail(this.email_id)
    this.email = <Email>await this.emailService.getEmail(this.email_id);

    if (!this.email.structure.empty) {
      this.emailEditor.loadDesign(this.email.structure)
    }
  }

  @ViewChild(EmailEditorComponent, { static: false })
  private emailEditor: EmailEditorComponent;

  // called when the editor is created
  editorLoaded() {
    console.log('editorLoaded');
    // load the design json here
    // this.emailEditor.editor.loadDesign({});
  }

  // called when the editor has finished loading
  editorReady() {
    console.log('editorReady');
  }

  showPreview() {
    let url = "/l/" + this.email_id
    window.open(url, '_blank').focus();
  }

  async save() {
    this.emailEditor.saveDesign(async (dataJson) => {
      console.log(dataJson)
      this.emailEditor.editor.exportHtml(async (data) =>
        await this.emailService.editEmail({ structure: dataJson, html: data.html, name: this.email.name }, this.email_id)
      );

    }
    );
  }

  async exportHtml() {
    await this.save();
    downloadURI("data:text/html," + encodeURIComponent(this.email.html), this.email.name + ".html")
  }



}

function downloadURI(dataurl, filename) {
  const link = document.createElement("a");
  link.href = dataurl;
  link.download = filename;
  link.click();
}
